import { useAutoneTranslation } from '@autone/translations';
import { NumberInput, type NumberInputProps } from '@autone/ui-next/atoms';
import { type TFunction } from 'i18next';
import { Trans } from 'react-i18next';

import { type APP_NAME } from '../../../../consts';

interface DoubleConfirmationInputProps extends NumberInputProps {
  selectedRowCount: number;
}

export const DoubleConfirmationInput = ({
  selectedRowCount,
  ...props
}: DoubleConfirmationInputProps) => {
  const { t } = useAutoneTranslation<typeof APP_NAME>();

  return (
    <div className="w-full flex flex-col gap-1">
      <label htmlFor="assort-unassort-double-confirmation-input">
        <Trans
          t={t as unknown as TFunction}
          i18nKey="bulk-actions.double-confirmation-input.label"
          values={{ count: selectedRowCount }}
        />
      </label>
      <NumberInput
        showStepper={false}
        placeholder={t('bulk-actions.double-confirmation-input.placeholder', {
          count: selectedRowCount,
        })}
        {...props}
      />
    </div>
  );
};
